module.exports = __webpack_public_path__ + "img/igluglow2 - copia.5b8cca29.jpg";